import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";
import Header from "../components/Header";
import Footer from "../components/Footer";

function Rut() {
    function formatDate(m) {
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    const [payment, setPayment] = useState(null);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/payment/paymentus`, {})
            .then((res) => {
                setPayment(res.data.data);
            })
            .catch((err) => function () {});
            
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    // Lọc ra danh sách chỉ chứa các giao dịch "RÚT"
    const withdrawHistory = payment ? payment.filter(item => item?.type_payment === "RÚT") : [];

    return (
        <AnimatedPage>
            <Header profile={profile} />

            <style>{`
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    overflow-y: auto !important;
                    background-color: #e3e1e2 !important; 
                    margin: 0; padding: 0;
                }
                
                .history-wrapper {
                    padding-bottom: 100px;
                    background-color: #e3e1e2;
                    min-height: 100vh;
                }

                /* ================================================== */
                /* 1. THÔNG TIN USER (GIỐNG PROFILE)                  */
                /* ================================================== */
                .center-head {
                    width: 100%;
                    height: 180px;
                    background: url('https://dztwieyphe62d.cloudfront.net/content/images/main/user/banner-center.jpg') center top no-repeat;
                    background-size: cover;
                    padding: 0 20px; 
                    display: flex;
                    align-items: center; 
                    color: #fff;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                }
                .profile-avatar-wrapper { position: relative; margin-right: 15px; flex-shrink: 0; }
                .profile-avatar { width: 65px; height: 65px; background-color: #fff; border-radius: 50%; display: flex; justify-content: center; align-items: center; }
                .profile-avatar i { font-size: 38px; color: #ffca28; }
                .profile-v1-badge { position: absolute; top: -2px; right: -5px; background-color: #ff9800; color: #fff; border-radius: 50%; width: 20px; height: 20px; display: flex; justify-content: center; align-items: center; font-size: 11px; font-weight: bold; border: 2px solid #222; }
                .profile-info { flex: 1; display: flex; flex-direction: column; justify-content: center; text-align: left; }
                .profile-info h3 { margin: 0 0 2px 0; font-size: 16px; font-weight: bold; color: #fff; }
                .profile-info p.email { margin: 0 0 6px 0; font-size: 13px; color: #ddd; }
                .profile-stats p { margin: 2px 0; font-size: 13px; color: #fff; }
                .profile-stats span { color: #ff9800; font-weight: bold; }

                /* ================================================== */
                /* 2. TIÊU ĐỀ TRANG VÀ NÚT BACK                       */
                /* ================================================== */
                .page-header-box {
                    display: flex;
                    align-items: center;
                    padding: 15px;
                    background: transparent;
                }
                .back-btn {
                    background: #fff;
                    color: #b71c1c;
                    width: 35px;
                    height: 35px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-right: 15px;
                }
                .back-btn:active { background: #f0f0f0; }
                .page-title-h1 {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333;
                    margin: 0;
                    text-transform: uppercase;
                }

                /* ================================================== */
                /* 3. DANH SÁCH THẺ LỊCH SỬ                           */
                /* ================================================== */
                .history-content {
                    padding: 0 15px;
                }
                .history-card {
                    background: #fff;
                    border-radius: 8px;
                    padding: 15px;
                    margin-bottom: 12px;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.08);
                    position: relative;
                }
                .h-top {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 8px;
                    border-bottom: 1px solid #f0f0f0;
                    padding-bottom: 8px;
                }
                .h-type {
                    font-weight: bold;
                    font-size: 15px;
                    color: #333;
                }
                .h-status {
                    font-size: 12px;
                    font-weight: bold;
                    padding: 4px 8px;
                    border-radius: 4px;
                }
                .status-pending { background: #fff3cd; color: #ff9800; }
                .status-success { background: #e8f5e9; color: #4caf50; }
                .status-lose { background: #ffebee; color: #f44336; }

                .h-mid {
                    font-size: 13px;
                    color: #555;
                    margin-bottom: 8px;
                    line-height: 1.5;
                }

                .h-bot {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                }
                .h-money {
                    font-size: 16px;
                    font-weight: bold;
                    color: #b71c1c; 
                }
                .h-date {
                    font-size: 12px;
                    color: #999;
                }
                
                .empty-history {
                    text-align: center;
                    color: #888;
                    margin-top: 50px;
                    font-size: 14px;
                }
            `}</style>

            <div className="history-wrapper">
                
                {/* 2. TIÊU ĐỀ TRANG */}
                <div className="page-header-box">
                    <h1 className="page-title-h1">Lịch sử rút điểm</h1>
                </div>

                {/* 3. NỘI DUNG LỊCH SỬ */}
                <div className="history-content">
                    {withdrawHistory.length > 0 ? (
                        withdrawHistory.map((item, index) => {
                            let statusClass = "status-lose";
                            let statusText = "Thất bại";
                            
                            if (item?.status_payment === "Pending") {
                                statusClass = "status-pending";
                                statusText = "Chờ xử lý";
                            } else if (item?.status_payment === "Success") {
                                statusClass = "status-success";
                                statusText = "Thành công";
                            }

                            return (
                                <div className="history-card" key={index}>
                                    <div className="h-top">
                                        <div className="h-type">{item?.type_payment}</div>
                                        <div className={`h-status ${statusClass}`}>
                                            {statusText}
                                        </div>
                                    </div>
                                    
                                    <div className="h-mid">
                                        <div>STK : <b>{item?.detail}</b></div>
                                    </div>
                                    
                                    <div className="h-bot">
                                        <div className="h-money">
                                            {item?.status_payment === "Pending" ? "-" : item?.status_payment === "Success" ? "-" : ""}
                                            {/* Chia 1000 và hiển thị chữ Điểm */}
                                            {Math.floor((item?.money || 0) / 1000).toLocaleString('vi-VN')} Điểm
                                        </div>
                                        <div className="h-date">{formatDate(new Date(item?.createdAt))}</div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="empty-history">
                            Chưa có dữ liệu lịch sử rút điểm.
                        </div>
                    )}
                </div>
            </div>
            
            <Footer profile={profile} />
        </AnimatedPage>
    );
}

export default Rut;